// extracted by mini-css-extract-plugin
export default {"title":"style_title__Ch+vm","title-form":"style_title-form__aZuCH"};